  <template>
    <b-container>
      <b-row class="mt-100 mt-sm-70 search-wrap mb-50">
        <b-col xl="12" lg="12" md="12">
          <b-card no-body class="freelancer-wrap mt-0 bg-white">
            <ul class="nav nav-pills mb-3 py-2 px-0" id="pills-tab" role="tablist">
              <a href="javascript:void(0);" @click="$router.push('/freelancer/search').catch(()=>{})">
              
              <li class="nav-item" role="presentation">
                <button class="nav-link return-to-search" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-home" aria-selected="true" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 1024 1024" class="icon" version="1.1"><path d="M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z" fill="#F2613C"/></svg>
                   return to search
                  </button>
              </li></a>
              <!-- <li class="nav-item" role="presentation">
                <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" v-on:click="filterByData()">Saved Jobs <span class="badge badge-secondary br-50" v-html="(proposalDetails.saved_job > 0)?proposalDetails.saved_job:''"></span></button>
              </li> -->
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                  <!-- <div class="search-filter-wrapper px-4 border-bottom pb-3 mb-3"> -->
                    <!-- <b-row> -->
                      <!-- <b-col xl="12" lg="12" md="12"> -->
                        <!-- <div class="input-group search-bar">
                          <input type="text" class="form-control border-none" v-model="filtersValue.title" placeholder="Search for jobs" @keyup="filterByData()" aria-describedby="basic-addon2">
                          <span class="input-group-text bg-white" id="basic-addon2">
                            <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9689 5.13525C16.0046 5.13525 17.9184 5.92799 19.3579 7.36746C20.7973 8.8069 21.59 10.7207 21.5901 12.7564C21.5901 14.7921 20.7973 16.706 19.3579 18.1454C17.9184 19.5849 16.0046 20.3776 13.9689 20.3776C11.9332 20.3776 10.0193 19.5849 8.57987 18.1454C7.14039 16.706 6.34766 14.7921 6.34766 12.7564C6.34766 10.7207 7.14039 8.8069 8.57987 7.36746C10.0193 5.92799 11.9331 5.13525 13.9689 5.13525ZM7.80186 12.7564C7.80186 16.1569 10.5683 18.9234 13.9688 18.9234C17.3693 18.9234 20.1358 16.1569 20.1358 12.7564C20.1358 9.35594 17.3694 6.58946 13.9689 6.58946C10.5684 6.58946 7.80186 9.35594 7.80186 12.7564Z" fill="#F2613C"/>
                              <path d="M24.1347 21.8942L19.3548 17.1143C19.0708 16.8304 18.6104 16.8304 18.3265 17.1143C18.0425 17.3983 18.0425 17.8587 18.3265 18.1426L23.1063 22.9225C23.2483 23.0645 23.4344 23.1355 23.6205 23.1355C23.8066 23.1355 23.9927 23.0645 24.1347 22.9225C24.4186 22.6385 24.4186 22.1782 24.1347 21.8942Z" fill="#F2613C"/>
                            </svg>
                          </span>
                        </div> -->
                      <!-- </b-col> -->
                      <!--<b-col xl="1" lg="1" md="12">
                        <div class="input-group search-bar">
                          <button class="btn btn-theme" @click="$refs['edit-category-modal'].show()">Filter</button>
                          <b-modal ref="edit-category-modal" size="lg" title="Filter By Skills" class="edit-category-modal" no-close-on-backdrop >
                            <div class="text-left">
                              <h5 class="text-black fz-20 fw-600" v-if="filterTags.length > 0">
                                Selected Skills
                              </h5>
                              <div class="card-section">
                                <div class="mb-0 fz-14 tags">
                                  <span
                                    v-for="(tag, tagIndex) in filterTags"
                                    :key="tagIndex"
                                    class="up-skill-badge inline-block"
                                  >
                                    <div class="d-flex align-items-center">
                                      {{ tag.skill_name }}
                                      <a href="javascript:" class="text-muted d-inline-flex">
                                        <div class="up-icon xs" @click="removeSkill(tagIndex)">
                                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2" v-on:click="removefromCategoryarr(cids)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#F2613C"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#F2613C"></rect></svg>
                                        </div>
                                      </a>
                                    </div>
                                  </span>
                                  
                                </div>
                                <div
                                  v-for="(role, index) in qrRoleMasterList"
                                  :key="index"
                                  class="mt-3 accordion"
                                >
                                  <b-button
                                    v-b-toggle="[`collapse-${index}`]"
                                    class="mb-0 d-block"
                                    >{{ role.role_name }}
                                    <i
                                      class="float-right fa fa-chevron-down fw-400 text-muted fz-12"
                                    ></i
                                  ></b-button>
                                  <b-collapse :id="`collapse-${index}`">
                                    <b-card>
                                      <div class="mb-30 tags">
                                        <span
                                          class="cursor-pointer up-skill-badge hover:bg-gray-100 inline-block"
                                          v-for="(skill, index1) in role.skills"
                                          :key="index1"
                                          @click="selectedSkills(skill)"
                                        >
                                          {{ skill.skill_name }}
                                        </span>
                                      </div>
                                    </b-card>
                                  </b-collapse>
                                </div>
                              </div>
                            </div>
                            <template #modal-footer>
                              <div class="text-right w-100">
                                <a
                                  href="javascript:void(0);"
                                  @click="clearFilter()"
                                  class="mr-2 text-theme"
                                >
                                  Cancel
                                </a>
                                <b-button
                                  size="lg"
                                  class="btn btn-theme"
                                  @click="filterByData()"
                                >
                                  Apply
                                </b-button>
                              </div>
                            </template>
                          </b-modal>
                        </div>
                      </b-col>
                      <b-col xl="12" lg="12" md="12">
                        <div class="card-section">
                          <div class="mb-0 fz-14 tags">
                            <span
                              v-for="(tag, tagIndex) in filterTags"
                              :key="tagIndex"
                              class="up-skill-badge inline-block"
                            >
                              <div class="d-flex align-items-center">
                                {{ tag.skill_name }}
                                <a href="javascript:" class="text-muted d-inline-flex">
                                  <div class="up-icon xs" @click="removeSkill(tagIndex)">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2" v-on:click="removefromCategoryarr(cids)"><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703924 0.710276 -0.703924 0.710276 9.22266 3.08838)" fill="#F2613C"></rect><rect width="0.878423" height="8.78423" rx="0.439212" transform="matrix(0.703929 -0.71027 0.703929 0.71027 3.03906 3.7124)" fill="#F2613C"></rect></svg>
                                  </div>
                                </a>
                              </div>
                            </span>
                            
                          </div>
                        </div>
                      </b-col>-->
                    <!-- </b-row> -->
                    
                  <!-- </div> -->
                <div v-if="dataStatus">
                  <div class="job-card py-2 px-4 pb-4 mb-2 position-relative freelanceSearch cursor-pointer" v-b-toggle.sidebar-right  v-for="(data,index) in postData" :key="index"  :id="data.jobs_id"  v-on:click="postDetailsclick(data.jobs_id)">
                  <div class="action-btn">
                   <!-- <button type="button" v-if="filterValue!=10" class="btn btn-secondary br-50 mr-1 btn-like" v-on:click="(event) => { event.stopPropagation(); dislikePost(data.jobs_id); }">
                      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2511_17183)">
                        <path d="M17.3943 5.88297C17.7631 6.35349 17.9401 6.85788 17.9175 7.37733C17.8949 7.94947 17.6389 8.3974 17.4281 8.67218C17.6728 9.28197 17.7669 10.2418 16.9501 10.9871C16.3516 11.5329 15.3353 11.7776 13.9275 11.7098C12.9376 11.6647 12.1094 11.4802 12.0756 11.4727H12.0718C11.8836 11.4388 11.6841 11.3974 11.4808 11.3522C11.4658 11.5931 11.5072 12.1916 11.9514 13.5392C12.4783 15.1427 12.4482 16.3698 11.8535 17.1904C11.2286 18.0524 10.2312 18.1201 9.93755 18.1201C9.65524 18.1201 9.39552 18.0034 9.21108 17.7889C8.79326 17.3033 8.8422 16.4074 8.89489 15.9934C8.39803 14.6609 7.00531 11.3936 5.82714 10.4865C5.80456 10.4714 5.78574 10.4526 5.76692 10.4338C5.42062 10.0687 5.18724 9.67344 5.02915 9.32714C4.80707 9.44759 4.55487 9.51535 4.28385 9.51535H1.98775C1.122 9.51535 0.421875 8.81146 0.421875 7.94947V1.83278C0.421875 0.967037 1.12576 0.266912 1.98775 0.266912H4.28385C4.61886 0.266912 4.93128 0.372307 5.18724 0.552984L6.07181 0.44759C6.20732 0.428768 8.61635 0.123875 11.0894 0.17281C11.5373 0.138931 11.9589 0.12011 12.3504 0.12011C13.0241 0.12011 13.6113 0.172808 14.1007 0.278204C15.2525 0.522871 16.0392 1.01221 16.4382 1.73115C16.7431 2.28071 16.7431 2.82651 16.6941 3.17281C17.4432 3.85035 17.5749 4.59941 17.5486 5.12639C17.5335 5.43128 17.4658 5.691 17.3943 5.88297ZM1.98775 1.28322C1.68285 1.28322 1.43819 1.53165 1.43819 1.83278V7.95324C1.43819 8.25813 1.68662 8.5028 1.98775 8.5028H4.28385C4.58875 8.5028 4.83342 8.25437 4.83342 7.95324V1.83655C4.83342 1.53165 4.58498 1.28699 4.28385 1.28699H1.98775V1.28322ZM16.4306 6.32338C16.2726 6.15775 16.2424 5.90556 16.3629 5.70982C16.3629 5.70606 16.5172 5.44257 16.536 5.08122C16.5624 4.58812 16.3253 4.15148 15.8284 3.77883C15.6515 3.64332 15.58 3.40995 15.6552 3.19916C15.6552 3.19539 15.8171 2.69853 15.5536 2.22802C15.3014 1.77632 14.7406 1.45261 13.8899 1.27193C13.2086 1.12513 12.2826 1.09878 11.1458 1.18912C11.1308 1.18912 11.112 1.18912 11.0931 1.18912C8.67281 1.13642 6.22614 1.45261 6.19979 1.45637H6.19602L5.81585 1.50154C5.83843 1.60694 5.84973 1.71986 5.84973 1.83278V7.95324C5.84973 8.11509 5.82338 8.27319 5.77821 8.41999C5.84596 8.67218 6.03417 9.23304 6.47833 9.71108C8.16842 11.0511 9.82086 15.5718 9.89238 15.7675C9.9225 15.8466 9.93002 15.9332 9.91497 16.0197C9.85098 16.4413 9.87356 16.957 9.9639 17.1113C10.1634 17.1076 10.7017 17.0511 11.0254 16.6032C11.4093 16.0724 11.3943 15.1239 10.9802 13.8667C10.3478 11.9507 10.2951 10.9419 10.7958 10.4978C11.0442 10.2757 11.3754 10.2644 11.6163 10.351C11.846 10.4037 12.0643 10.4488 12.2713 10.4827C12.2864 10.4865 12.3052 10.4903 12.3202 10.494C13.4758 10.7462 15.5461 10.9005 16.265 10.2456C16.8748 9.6885 16.4419 8.95073 16.393 8.87168C16.2537 8.66089 16.2951 8.38611 16.4833 8.21673C16.4871 8.21296 16.8823 7.84031 16.9012 7.33969C16.9162 7.00468 16.7581 6.66215 16.4306 6.32338Z" fill="black"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_2511_17183">
                        <rect width="18" height="18" fill="white" transform="matrix(1 0 0 -1 0.171875 18.1201)"/>
                        </clipPath>
                        </defs>
                      </svg>
                    </button>-->
                    <button type="button" v-if="data.action == 3" class="btn btn-secondary br-50 btn-archive saved-btn btn-archive heart" :id="'res_'+data.jobs_id" v-on:click="(event) => { event.stopPropagation(); savePost(data, index); }">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="#f2613c">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="#f2613c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <!-- <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.82903 0.620117H11.997C12.6246 0.620117 13.1542 1.12649 13.1542 1.77727L13.1542 16.8113C13.1542 16.8115 13.1542 16.8116 13.1542 16.8118C13.1524 17.5271 12.2615 17.9031 11.7348 17.3707L11.7329 17.3688L7.8604 13.4974C7.35368 12.9738 6.47239 12.9738 5.96568 13.4974L2.0932 17.3688L2.09124 17.3707C1.56473 17.903 0.67387 17.5274 0.671875 16.8118V1.77727C0.671875 1.12649 1.20151 0.620117 1.82903 0.620117Z" stroke="black"/>
                      </svg> -->
                    </button>
                    <button type="button" v-else class="btn btn-secondary br-50 btn-archive heart" :id="'res_'+data.jobs_id" v-on:click="(event) => { event.stopPropagation(); savePost(data, index); }">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="#f2613c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                  <span class="job-posted-text">Posted {{data.time}}</span>
                  <h5 class="text-black fz-18 fw-600 title-heading mb-0 freelancer-search-name" v-on:click="postDetailsclick(data.jobs_id)">{{data.job_title}}</h5>
                  
                  <div>

                    <ul class="d-md-flex align-items-center fw-600 fz-14 post text-muted mb-2 freelancer-search-page-ul" v-on:click="postDetailsclick(data.jobs_id)">

                      <li class="find-job-flex category"><svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 4.5L4.5 3.75H10.5L11.25 4.5V10.5L10.5 11.25H4.5L3.75 10.5V4.5ZM5.25 5.25V9.75H9.75V5.25H5.25ZM13.5 3.75L12.75 4.5V10.5L13.5 11.25H19.5L20.25 10.5V4.5L19.5 3.75H13.5ZM14.25 9.75V5.25H18.75V9.75H14.25ZM17.25 20.25H15.75V17.25H12.75V15.75H15.75V12.75H17.25V15.75H20.25V17.25H17.25V20.25ZM4.5 12.75L3.75 13.5V19.5L4.5 20.25H10.5L11.25 19.5V13.5L10.5 12.75H4.5ZM5.25 18.75V14.25H9.75V18.75H5.25Z" fill="#00000085"/></svg>
                        {{data.quality_inspector}}</li> 
                      <li class="find-job-flex">
                        <svg width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 5.28027C8.37764 5.28027 5.40918 8.40136 5.40918 12.2748C5.40918 14.3585 6.46842 16.8771 8.23787 19.6617C8.85278 20.6294 9.51552 21.5658 10.1854 22.4404C10.6054 22.9889 10.952 23.4148 11.1785 23.6801C11.6242 24.202 12.3759 24.2018 12.8214 23.68C13.0479 23.4148 13.3945 22.9889 13.8145 22.4404C14.4844 21.5658 15.1471 20.6294 15.762 19.6617C17.5315 16.8771 18.5907 14.3585 18.5907 12.2748C18.5906 8.40135 15.6222 5.28027 11.9999 5.28027ZM9.18859 18.847C7.55932 16.283 6.59072 13.9799 6.59072 12.2748C6.59072 9.19124 9.00544 6.65236 11.9999 6.65236C14.9944 6.65236 17.4091 9.19123 17.4092 12.2748C17.4092 13.9799 16.4406 16.283 14.8113 18.847C13.7963 20.4444 12.7477 21.8156 11.9999 22.6934C11.2521 21.8155 10.2036 20.4443 9.18859 18.847ZM12 14.7608C10.7673 14.7608 9.77138 13.5702 9.77138 12.1142C9.77138 10.6582 10.7673 9.4677 12 9.4677C13.2326 9.4677 14.2285 10.6582 14.2285 12.1142C14.2285 13.5703 13.2326 14.7608 12 14.7608ZM12 13.5663C12.6578 13.5663 13.1999 12.9182 13.1999 12.1142C13.1999 11.3103 12.6578 10.6621 12 10.6621C11.3421 10.6621 10.7999 11.3103 10.7999 12.1142C10.7999 12.9182 11.3421 13.5663 12 13.5663Z" fill="#00000085"></path></svg>
                         {{data.country_name+', '+data.state_name+', '+data.city_name}}
                      </li> 
                      
                    </ul>
                  </div>

                   
                  <!-- <vue-read-more-smooth :lines="3" class="mt-2 mb-2"> -->
                    <vue-read-more-smooth :lines="3" class="mt-2">
                      <p class="fz-14 text-black mb-2" v-html="getHtmlContent(data.scope_of_work)" v-on:click="postDetailsclick(data.jobs_id)"></p>
                    </vue-read-more-smooth>
                  <p class="fz-16 text-black mb-2 search-description" v-html="(data.scope_of_work)" v-on:click="postDetailsclick(data.jobs_id)"> </p>
                  <!-- <p class="fz-16 text-black mb-2" v-html="getHtmlContent(data.scope_of_work)"  v-b-toggle.sidebar-right v-on:click="postDetailsclick(data.jobs_id)"> </p> -->
                  <!-- </vue-read-more-smooth> -->
                    
                  <p class="fz-14 text-black client-location"><svg width="24" height="29" viewBox="0 0 24 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 5.28027C8.37764 5.28027 5.40918 8.40136 5.40918 12.2748C5.40918 14.3585 6.46842 16.8771 8.23787 19.6617C8.85278 20.6294 9.51552 21.5658 10.1854 22.4404C10.6054 22.9889 10.952 23.4148 11.1785 23.6801C11.6242 24.202 12.3759 24.2018 12.8214 23.68C13.0479 23.4148 13.3945 22.9889 13.8145 22.4404C14.4844 21.5658 15.1471 20.6294 15.762 19.6617C17.5315 16.8771 18.5907 14.3585 18.5907 12.2748C18.5906 8.40135 15.6222 5.28027 11.9999 5.28027ZM9.18859 18.847C7.55932 16.283 6.59072 13.9799 6.59072 12.2748C6.59072 9.19124 9.00544 6.65236 11.9999 6.65236C14.9944 6.65236 17.4091 9.19123 17.4092 12.2748C17.4092 13.9799 16.4406 16.283 14.8113 18.847C13.7963 20.4444 12.7477 21.8156 11.9999 22.6934C11.2521 21.8155 10.2036 20.4443 9.18859 18.847ZM12 14.7608C10.7673 14.7608 9.77138 13.5702 9.77138 12.1142C9.77138 10.6582 10.7673 9.4677 12 9.4677C13.2326 9.4677 14.2285 10.6582 14.2285 12.1142C14.2285 13.5703 13.2326 14.7608 12 14.7608ZM12 13.5663C12.6578 13.5663 13.1999 12.9182 13.1999 12.1142C13.1999 11.3103 12.6578 10.6621 12 10.6621C11.3421 10.6621 10.7999 11.3103 10.7999 12.1142C10.7999 12.9182 11.3421 13.5663 12 13.5663Z" fill="#00000085"></path></svg>
                     Client Location - <span class="text-muted" v-on:click="postDetailsclick(data.jobs_id)">{{data.client_country}}</span></p>
                  <!-- <div class="skill-slider-wrapper mt-0">
                    <b-row class="mt-0" v-if="data.skill_name.length > 0">
                      <b-col xl="12" lg="12" md="12" sm="12" class="col-12" :class="'ali-'+data.skill_name.length" v-if="data.skill_name">
                        <div class="skills" :id="'skill-'+index"> -->
                          <!-- {{data.skill_name}} -->
                          <!-- <template v-for="(skill,skill_index) in data.skill_name"> -->
                            <!-- {{skill}} -->
                            <!-- <span class="skill" :key="skill_index" :class="'skill-'+index" :id="'skill-'+index+'-'+skill_index" >{{(!checkskills('skill',index,skill_index,data.skill_name.length))?'':skill}}</span>
                          </template>
                            <span class="cursor-pointer skill" :id="'skill-append-'+index" :class="'skill-append-'+index" style="display:none;" v-b-toggle.sidebar-right v-on:click="postDetailsclick(data.jobs_id)"></span>
                        </div>
                      </b-col>
                    </b-row>
                  </div> -->
                  
                </div>
                  <template v-if="loaderStatus">
                      <div class="p-3">
                        <div class="freelancer-search-loader-box d-flex align-items-start p-2 rounded mb-3" >
                            <!-- Text Placeholders -->
                            <div class="flex-grow-1">
                              <div class="title-placeholder shimmer mb-2"></div>
                              <div class="subtitle-placeholder shimmer mb-2"></div>
                              <div class="description-placeholder shimmer mb-2"></div>
                              <div class="location-placeholder shimmer mb-2"></div>

                              <!-- Inline Tags -->
                              <div class="d-flex flex-wrap gap-2">
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                              </div>
                            </div>

                            <!-- Round Shape Placeholder -->
                            <div class="d-flex flex-wrap gap-2">
                              <div class="round-placeholder shimmer ms-auto"></div>
                            </div>
                        </div>
                        <div class="freelancer-search-loader-box d-flex align-items-start p-2 rounded mb-3" >
                            <!-- Text Placeholders -->
                            <div class="flex-grow-1">
                              <div class="title-placeholder shimmer mb-2"></div>
                              <div class="subtitle-placeholder shimmer mb-2"></div>
                              <div class="description-placeholder shimmer mb-2"></div>
                              <div class="location-placeholder shimmer mb-2"></div>

                              <!-- Inline Tags -->
                              <div class="d-flex flex-wrap gap-2">
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                              </div>
                            </div>

                            <!-- Round Shape Placeholder -->
                            <div class="d-flex flex-wrap gap-2">
                              <div class="round-placeholder shimmer ms-auto"></div>
                            </div>
                        </div>
                        <div class="freelancer-search-loader-box d-flex align-items-start p-2 rounded mb-3" >
                            <!-- Text Placeholders -->
                            <div class="flex-grow-1">
                              <div class="title-placeholder shimmer mb-2"></div>
                              <div class="subtitle-placeholder shimmer mb-2"></div>
                              <div class="description-placeholder shimmer mb-2"></div>
                              <div class="location-placeholder shimmer mb-2"></div>

                              <!-- Inline Tags -->
                              <div class="d-flex flex-wrap gap-2">
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                              </div>
                            </div>

                            <!-- Round Shape Placeholder -->
                            <div class="d-flex flex-wrap gap-2">
                              <div class="round-placeholder shimmer ms-auto"></div>
                            </div>
                        </div>
                      </div>
                    </template>
                  <!-- <div class="text-center py-4 text-theme" v-if="loaderStatus">
                    <b-spinner type="border" medium></b-spinner>
                  </div> -->
                </div>
                <template v-else-if="dataStatus && postData.length == 0">
                  <div class="p-3">
                        <div class="freelancer-search-loader-box d-flex align-items-start p-2 rounded mb-3" >
                            <!-- Text Placeholders -->
                            <div class="flex-grow-1">
                              <div class="title-placeholder shimmer mb-2"></div>
                              <div class="subtitle-placeholder shimmer mb-2"></div>
                              <div class="description-placeholder shimmer mb-2"></div>
                              <div class="location-placeholder shimmer mb-2"></div>

                              <!-- Inline Tags -->
                              <div class="d-flex flex-wrap gap-2">
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                              </div>
                            </div>

                            <!-- Round Shape Placeholder -->
                            <div class="d-flex flex-wrap gap-2">
                              <div class="round-placeholder shimmer ms-auto"></div>
                              <div class="round-placeholder shimmer ms-auto"></div>
                            </div>
                        </div>
                        <div class="freelancer-search-loader-box d-flex align-items-start p-2 rounded mb-3" >
                            <!-- Text Placeholders -->
                            <div class="flex-grow-1">
                              <div class="title-placeholder shimmer mb-2"></div>
                              <div class="subtitle-placeholder shimmer mb-2"></div>
                              <div class="description-placeholder shimmer mb-2"></div>
                              <div class="location-placeholder shimmer mb-2"></div>

                              <!-- Inline Tags -->
                              <div class="d-flex flex-wrap gap-2">
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                              </div>
                            </div>

                            <!-- Round Shape Placeholder -->
                            <div class="d-flex flex-wrap gap-2">
                              <div class="round-placeholder shimmer ms-auto"></div>
                              <div class="round-placeholder shimmer ms-auto"></div>
                            </div>
                        </div>
                        <div class="freelancer-search-loader-box d-flex align-items-start p-2 rounded mb-3" >
                            <!-- Text Placeholders -->
                            <div class="flex-grow-1">
                              <div class="title-placeholder shimmer mb-2"></div>
                              <div class="subtitle-placeholder shimmer mb-2"></div>
                              <div class="description-placeholder shimmer mb-2"></div>
                              <div class="location-placeholder shimmer mb-2"></div>

                              <!-- Inline Tags -->
                              <div class="d-flex flex-wrap gap-2">
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                                <div class="tag-placeholder shimmer"></div>
                              </div>
                            </div>

                            <!-- Round Shape Placeholder -->
                            <div class="d-flex flex-wrap gap-2">
                              <div class="round-placeholder shimmer ms-auto"></div>
                              <div class="round-placeholder shimmer ms-auto"></div>
                            </div>
                        </div>
                      </div>
                  </template>
                <div v-else>
                  <div class="job-card py-8 px-4 pb-4 mb-2 text-center dashboard-empty">
                    <svg width="149" height="149" viewBox="0 0 149 149" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-2 m-auto">
                      <path d="M66.1246 6.34896C71.2699 2.78071 78.0895 2.78071 83.2348 6.34896C86.5425 8.64289 90.6329 9.51233 94.5877 8.76211C100.74 7.59512 106.97 10.3689 110.219 15.7214C112.307 19.1624 115.691 21.6204 119.609 22.5436C125.703 23.9797 130.266 29.0476 131.057 35.2589C131.566 39.252 133.657 42.8736 136.861 45.3106C141.844 49.1014 143.952 55.5872 142.148 61.5833C140.989 65.438 141.426 69.5969 143.361 73.1263C146.372 78.6164 145.659 85.3986 141.573 90.1427C138.946 93.1926 137.653 97.1697 137.986 101.181C138.504 107.421 135.094 113.327 129.431 115.999C125.791 117.717 122.992 120.824 121.665 124.624C119.6 130.536 114.082 134.544 107.822 134.682C103.798 134.77 99.9778 136.471 97.2192 139.402C92.9283 143.962 86.2577 145.38 80.483 142.96C76.7706 141.404 72.5888 141.404 68.8764 142.96C63.1017 145.38 56.4311 143.962 52.1401 139.402C49.3816 136.471 45.5613 134.77 41.537 134.682C35.277 134.544 29.7598 130.536 27.6946 124.624C26.3669 120.824 23.5687 117.717 19.9282 115.999C14.2654 113.327 10.8556 107.421 11.3732 101.181C11.7059 97.1697 10.4136 93.1926 7.78652 90.1427C3.7 85.3986 2.98715 78.6164 5.99803 73.1263C7.93364 69.5969 8.37075 65.438 7.21125 61.5833C5.40762 55.5872 7.51499 49.1014 12.4986 45.3106C15.7024 42.8736 17.7933 39.252 18.3019 35.2589C19.093 29.0476 23.6562 23.9797 29.7508 22.5436C33.6688 21.6204 37.052 19.1624 39.1407 15.7214C42.3898 10.3689 48.6199 7.59512 54.7716 8.76211C58.7264 9.51233 62.8169 8.64289 66.1246 6.34896Z" fill="#F2613C"/>
                      <path d="M68.7901 83.7077H76.827L84.2389 55.3104L86.8286 44.0586H74.5945L72.8978 55.3104L68.7901 83.7077ZM68.8794 104.961C74.0587 104.961 77.6307 100.496 77.6307 96.0311C77.6307 92.1912 75.1303 89.3336 71.2904 89.3336C66.1111 89.3336 62.5391 93.9772 62.5391 98.3529C62.5391 102.282 65.0395 104.961 68.8794 104.961Z" fill="white"/>
                    </svg>
                    <p class="fz-20 fw-600 text-black mb-0">No Post Available {{dataStatus}}</p>
                  </div>
                </div>
                <!-- right side bar  -->
                <sidebar ref="postDetailsc"></sidebar>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </template>
  <script>
    import axios from 'axios'
    import VueReadMoreSmooth from "vue-read-more-smooth"
    import { mapActions } from "vuex";
    import sidebar from  "@/components/freelancer/jobDetail-sidebar";


    export default { 
      components : {
        VueReadMoreSmooth, 
        sidebar
      },
      props:{
        // 'search':input,
      },
  
      data() {
        return {
          isHidden: true,
          headToken:'',
          postData:[],
          dataStatus: true,
          loaderStatus: true,
          filterValue:3,
          search:'',
          proposalDetails:'',
          
          proposalbtn_text:'Submit a Proposal',
          clientrating:false,
          proposal_url:0,
          jobLink:'',
          login_user_id:'',
          qrRoleMasterList: [],
          selectedTags:[],
          filtersValue:{
            title:'',
            category_ids:[],
            start_limit:0,
            end_limit:3
          },
          sliderScrollData:[],
          alreadySumittedJobData: '',
        }
      },
      methods: {
        ...mapActions(["genericAPIPOSTRequest"]),
        // this fun is for to check certificate
        checkcertificate(classId,pid,cid,_t){
          return setTimeout(() => {
            var maxWidth = document.getElementById(classId+'-'+pid).offsetWidth;
            var certificateListWidth = 40;
            document.querySelectorAll('.'+classId+'-'+pid).forEach(element => {
              certificateListWidth += parseInt(element.offsetWidth)+parseInt(20);
              if(parseInt(maxWidth) < parseInt(certificateListWidth)){
                element.remove();
              }
            });
            if(_t == cid+1){
              var renderCount = document.querySelectorAll('.'+classId+'-'+pid).length;
              // console.log('renderCount',_t,renderCount)
              if(_t > renderCount){
                document.getElementById(classId+'-append-'+pid).textContent = '+'+(_t-renderCount);
                document.getElementById(classId+'-append-'+pid).style.display = 'inline-block';
                // document.getElementById(classId+'-append-'+pid).insertAdjacentHTML('beforeend', '<span id="'+classId+'-'+pid+'-'+(renderCount+1)+'" class="skill">+'+(_t-renderCount)+'</span>');
              }else{
                document.getElementById(classId+'-append-'+pid).style.display = 'none';
              }
            }
            return true;
          }, 100);
        },
        SlideSkill(id,direction,_i){
          var slider_width = document.querySelector('#'+id).parentElement.scrollWidth;
          var main_width = document.querySelector('#'+id).scrollWidth;
          if(direction =='right'){
            if(this.sliderScrollData[_i] > 0){
              this.sliderScrollData[_i] = this.sliderScrollData[_i]+parseInt(slider_width);
            }else{
              this.sliderScrollData[_i] = parseInt(slider_width);
            }
            if(main_width > this.sliderScrollData[_i]){
              const conent = document.querySelector('#'+id);
              conent.scrollLeft += slider_width;
              if(this.sliderScrollData[_i] == main_width){
                document.getElementById('next_'+_i).style.display = 'none';
              }
              document.getElementById('prev_'+_i).style.display = 'block';
            }else if(this.sliderScrollData[_i] >= main_width){
              this.sliderScrollData[_i] = this.sliderScrollData[_i]-parseInt(slider_width);
              document.getElementById('next_'+_i).style.display = 'none';
            }
          }else{
            // currentSlide_position-=slider_width
            this.sliderScrollData[_i] = this.sliderScrollData[_i]-parseInt(slider_width);
            if(this.sliderScrollData[_i] >= 0){
              const conent = document.querySelector('#'+id);
              conent.scrollLeft -= slider_width;
              if(conent.scrollLeft==0){
                document.getElementById('prev_'+_i).style.display = 'none';
              }
              document.getElementById('next_'+_i).style.display = 'block';
            }else if(this.sliderScrollData[_i] < 0){
              document.getElementById('prev_'+_i).style.display = 'none';
              this.sliderScrollData[_i] = this.sliderScrollData[_i]+parseInt(slider_width);
            }
            
          }
          
        },
        // this fun is for to clear all filter value
        clearFilter(){
          this.filtersValue = {
            category_ids:[],
            start_limit:0,
            end_limit:3
          };
          this.selectedTags=[];
          this.postData = [];
          //this.$refs['edit-category-modal'].hide()
          this.filterByData();
        },
        // Categories Handling method
        selectedSkills(skill) {
          this.selectedTags.push(skill);
          this.filtersValue.category_ids.push(skill.qp_role_skill_master_id);
        },
        // this fun is for to remove selectd filter category
        removeSkill(index) {
          this.selectedTags.splice(index, 1);
          this.filtersValue.category_ids.splice(index, 1);
          this.filterByData();
        },
        
        
        // this function is for dislike the post
        dislikePost(post){
          var  passApidata= { "post_id": post, "dislike_reason": "Not Interested"};
          axios.post(this.$store.state.baseUrl+'/postDislike',passApidata,{headers: this.headToken}).then((response)=>{
            if(response.data.status ==  true){
              var  passApidata= {
                  "filter": this.filterValue,
                  "from": "search",
                  "search":{"location": [], "locationDis": [], "cid": []}
              };
              axios.post(this.$store.state.baseUrl+'/getJobsList',passApidata,{headers: this.headToken}).then((response)=>{
                if(response.data.status ==  true){
                  this.postData = response.data.result;
                  this.proposalDetails=response.data.dashboard;
                  this.loaderStatus= false;
                  if (this.filterValue == '') {
                    if (this.proposalDetails.recent_job > 0) this.dataStatus = true;
                    else this.dataStatus = false;
                  }
                  else if(this.filterValue == 3){
                    if (this.proposalDetails.saved_job > 0) this.dataStatus= true;
                    else this.dataStatus= false;
                  }else{
                    if (this.proposalDetails.dislike_job > 0) this.dataStatus= true;
                    else this.dataStatus= false;
                  }
                }else{
                  this.loaderStatus= false;
                  this.dataStatus= false;
                }
              });
              this.$toastr.s('Post Disliked successfull');
            }else{
              this.$toastr.e('Post Not Disliked');
            }
          });
        },
        //this fun is for to read jobpost
        async addJobRead(data){
          await this.genericAPIPOSTRequest({
              requestUrl: "addJobread",
              params: {"user_id":this.login_user_id,'job_id': data},
          });
          return true;
        },
        // this function is for get post details
        postDetailsclick(data){
          //this fun is for to read jobpost
          this.addJobRead(data);
          document.getElementById(data).classList.remove("unread-bg");
          this.$refs.postDetailsc.postDetails(data);
        },
        //  this fun for to go job post details 
        gotojobDetails(datas) {
          this.$router.push({
                        name: 'jobDetails', 
                        path:'/freelancer/job-details',
                        params: { jobDetailsWithClientData: datas }
                    }).catch(()=>{});
          // window.open(route.href);

        },
        //  this fun for to get post data 
        getData(filter){
          this.filterValue=filter;
          this.loaderStatus= true;
          var  passApidata= {
              "filter": filter,
              "from": "search",
              "search":{"location": [], "locationDis": [], "cid": []}
          };
          axios.post(this.$store.state.baseUrl+'/getJobsList',passApidata,{headers: this.headToken}).then((response)=>{
            if(response.data.status ==  true){
              this.postData = response.data.result;
              this.proposalDetails=response.data.dashboard;
              this.loaderStatus= false;
              if (this.filterValue == '') {
                  if (this.proposalDetails.recent_job > 0) this.dataStatus = true;
                    else this.dataStatus = false;
                  }
                  else if(this.filterValue == 3){
                    if (this.proposalDetails.saved_job > 0) this.dataStatus= true;
                    else this.dataStatus= false;
                  }else{
                    if (this.proposalDetails.dislike_job > 0) this.dataStatus= true;
                    else this.dataStatus= false;
                  }
                  
            }else{
              this.postData=[];
              this.loaderStatus= false;
              this.dataStatus= false;
            }
          });
        },
        //  this fun for to save & unsave post  
        async savePost(jobdata){
          var send_jobdata = {
            "action":3,
            "jobData":jobdata
          };
          var res = await this.genericAPIPOSTRequest({
              requestUrl: "job/addBookmark",
              params: send_jobdata,
          });
          if(res){
                var  passApidata1= {
                    "filter": this.filterValue,
                    "from": "search",
                    "search":{"location": [], "locationDis": [], "cid": []}
                };
                axios.post(this.$store.state.baseUrl+'/getJobsList',passApidata1,{headers: this.headToken}).then((response)=>{
                  if(response.data.status ==  true){
                    this.postData = response.data.result;
                    this.proposalDetails = response.data.dashboard;
                    
                    if (this.filterValue == '') {
                      if (this.proposalDetails.recent_job > 0) this.dataStatus = true;
                      else this.dataStatus = false;
                    }
                    else if(this.filterValue == 3){
                      if (this.proposalDetails.saved_job > 0) this.dataStatus= true;
                      else this.dataStatus = false;
                    }else{
                      if (this.proposalDetails.dislike_job > 0) this.dataStatus= true;
                      else this.dataStatus = false;
                    }
                    this.$toastr.s('Post Saved Successfull');
                  }else{
                    if (this.filterValue == '') {
                      this.proposalDetails.recent_job = (this.proposalDetails.recent_job - 1);
                    }else if(this.filterValue == 3){
                      this.proposalDetails.saved_job = (this.proposalDetails.saved_job - 1);
                    }else{
                      this.proposalDetails.saved_job = (this.proposalDetails.saved_job - 1);
                    }
                    this.loaderStatus = false;
                    this.dataStatus = false;
                    this.$toastr.e('Post Save Unsuccessfull');
                  }
                });
            }else{
                this.$toastr.e('Post Save Unsuccessfull');
                this.loaderStatus = false;
                this.dataStatus = false;
            }
        },
        // this fun is for get category and skills
        async getCategory(){
          var response = await this.genericAPIPOSTRequest({
              requestUrl: "common/getQpRoleMasterList",
          });
          if(response){
            this.qrRoleMasterList=response;
          }
        },
        // this function is for to get filter data
        async filterByData(){
          this.loaderStatus= true;
          var  passApidata= {
              "filter": 3,
              "from": "search",
              "search":{"category_ids":this.filtersValue.category_ids,"title":this.filtersValue.title}
          };
          axios.post(this.$store.state.baseUrl+'/getJobsList',passApidata,{headers: this.headToken}).then((response)=>{
            if(response.data.status ==  true){
              this.postData = response.data.result;
              this.proposalDetails=response.data.dashboard;
              this.loaderStatus= false; 
               if (this.filterValue == '') {
                  if (this.proposalDetails.recent_job > 0) this.dataStatus = true;
                  else this.dataStatus = false;
                }
                else if(this.filterValue == 3){
                  if (this.proposalDetails.saved_job > 0) this.dataStatus= true;
                  else this.dataStatus= false;
                }else{
                  if (this.proposalDetails.dislike_job > 0) this.dataStatus= true;
                  else this.dataStatus= false;
                }
            }else{
              this.postData=[];
              this.loaderStatus= false;
              this.dataStatus= false;
            }
          });
          //this.$refs['edit-category-modal'].hide();
        },
      },
      computed:{
        filteredAndSorted(){
        // function to compare names
          function compare(a, b) {
            if (a.job_title < b.job_title) return -1;
            if (a.job_title > b.job_title) return 1;
            return 0;
          }
          return this.postData.filter(user => {
              return user.job_title.toLowerCase().includes(this.search.toLowerCase());
          }).sort(compare);
        },
        //this fun for to show selected tags
        filterTags() {
          return Array.from(new Set(this.selectedTags.map(JSON.stringify))).map(
            JSON.parse
          );
        },
      },
      mounted() {
        var userdata = JSON.parse(localStorage.getItem('loginUserData'));
        this.login_user_id = userdata.login_master_id;
        // var userdata = JSON.parse(localStorage.getItem('loginUserData'));
        // this is header for api 
        this.headToken= {Authorization : 'Bearer '+this.$store.state.currentUserData.token, TimeZone : this.$store.state.userTimeZone};
        // this function is for to get all active jobs
        this.filterByData();
        //this fun for to get category
        this.getCategory();
      },  
    }
  </script>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700;900&display=swap');
    body{font-family: 'Source Sans Pro', sans-serif!important;}
    /*.freelancer-wrap .job-card:hover li{color:#F2613C!important;}*/
    .freelancer-wrap .job-card:hover {background-color: #eeeeee66!important;}
    .text-muted{color:#000!important;}
    .ralative {padding-bottom:0px;}
    .theme-bg{background-color: #FFF6F4!important;}
    .bg-none{background-color:transparent;}
     
    .br-20{border-radius: 20px;}
    .border-none{border:0px!important;}
    .search-wrap .br-50{border-radius:50%!important;}
    .search-wrap .fz-14{font-size:14px;}
    .search-wrap .card{border-radius: 20px!important;border: 0px;background-color: transparent;}
    .search-wrap .card-body{border-radius: 20px;}
    .search-wrap .card-body{border-radius:0 0 20px 20px;padding:0px;}
    .search-wrap .card-header{border-radius:0!important;background-color: transparent;text-align: left;border-radius:20px 20px 0 0!important;}
    .search-wrap .my-proposal ul{margin-left:-32px;}
    .search-wrap .tabs .card{border-radius: 20px!important;border: 0px;background-color: #fff;}
    .search-wrap .card-section select{-webkit-appearance: menulist !important; /* override vuetify style */-moze-appearance: menulist !important; /* override vuetify style */appearance: menulist !important; /* override vuetify style */
    }
    .fz-16{font-size:16px;}
    .fz-18{font-size:18px;}
    .fz-24{font-size:24px;}
    .fw-600{font-weight:600;}
    .mb-23{margin-bottom:23px;}
    .no-bottom-border{border-bottom:0px!important;}
    .border-top-0{border-top:0px!important;}
    .fz-34{font-size:34px;}
    .offer-wrap .card-body{padding:0px;}
    .mb-50{margin-bottom:50px!important;}
    p {margin-top: 0!important;margin-bottom: 1rem!important;}
    h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {margin-top: 0!important;margin-bottom: 0.5rem!important;font-weight: 500!important;line-height: 1.2!important;}
    dl, ol, ul {margin-top: 0!important;margin-bottom: 1rem!important;}
    ol, ul {padding-left: 2rem!important;}
    hr {margin: 1rem 0!important;}  
    .fz-30{font-size:26px!important;}
    .card-section .post {margin-left: -32px;}
    .card-section .tags span {background: #FCFCFC;border: 1px solid #d8d8d8;border-radius: 100px;padding: 1px 15px!important;font-size: 14px;--skill-height: 30px;margin: 0 5px 10px 0;padding: 0 10px;background-color: var(--skill-bg);border-radius: 12px;font-size: 12px;line-height: 2;cursor: default;}
    .btn-edit:hover{padding:8px 16px!important;background-color: #f2613da6!important;}
    .card-section .btn-social{font-family: 'Source Sans Pro';font-style: normal;font-weight: 400;font-size: 14px;line-height: 18px;text-align: center;color: #000000;background: #FFFFFF;border: 1px solid #000000;border-radius: 100px;text-align:center;width:100%;}
    .search-wrap .custom-control-label{background-color:transparent;}
    .border-none{border:0px;}
    .bg-theme{background-color:#F2613C!important;}
    .tt-menu .custom-control{margin-bottom: 5px;}
    .up-skill-container {
    --token-btn-gradient: transparent,var(--scroll-gradient-base,var(--semi-transparent-inverse));
    display: grid;
    align-items: center;
  }
  .bg-hover-theme:hover{background-color:#FFF6F4!important;}
  .up-skill-wrapper {
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;
    padding: 5px 0 15px;
    scrollbar-width: none;
  }
  .up-skill-container .up-btn, .up-skill-container .up-skill-wrapper {
    grid-row: 1/-1;
  }
  .up-skill-badge {
    margin-bottom: 0;
    flex: none;
    cursor: pointer;
  }
  .up-skill-badge {
    --skill-height: 30px;
    --skill-color:#000;
    --skill-bg: #fff;
    display: inline-flex;
    align-items: center;
    height: var(--skill-height);
    margin: 0 5px 10px 0;
    padding: 0 10px;
    color: #000;
    background-color: #fff;
    border-radius: 15px;
    font-size: 13px;
    line-height: 1;
    cursor: default;
    border:1px solid #F2613C;
    cursor:pointer;
  }
  .up-skill-container .up-btn:before {
    content: "";
    position: absolute;
    bottom: 0;
    height: 100%;
    width: var(--ws-lg);
  }
  .up-skill-container .up-btn.up-btn-next {
    padding-left: 10px;
  }
  .up-skill-container .up-btn {
    position: relative;
    margin: 4px 0 15px;
    height: 100%;
    padding: 0;
  }
  .up-btn-link {
    padding: var(--btn-link-padding);
    background-color: transparent;
    color: var(--link-color);
    text-transform: none;
    font-weight: var(--btn-weight);
    line-height: var(--font-size-base);
    box-shadow: none!important;
    border-color: transparent;
    border-radius: 0;
    max-height: unset;
  }
  .up-card-section {
    --card-padding-y: 20px;
  }
  .skill-slider-wrapper{
    position: relative;
  }
  .skill-slider-wrapper .prev-btn{
    position: absolute;
    top: -6px;
    z-index: 1;
    background-color: #fff;
    padding: 8px;
    left: 0px;
  }
  .skill-slider-wrapper .next-btn{
    position: absolute;
    top: -6px;
    z-index: 1;
    background-color: #fff;
    padding: 8px;
    right: 0px;
  }
  .skill-slider-wrapper .dynamic-slider-slide{
    margin:0 5px;text-align:center;
  }
  .skill-slider-wrapper .dynamic-slider-slide li{width: 100%;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .btn-archive.heart{
  padding: 10px !important;
  border: 2px solid #00000025;
  }
  .read-more-button.show-less {
    margin-top: 10px;
  }
  .return-to-search{
    color: #F2613C !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  
.find-job-flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right:10px ;
  gap:6px;
  color: #00000085;
}
.freelancer-search-page-ul{
  gap: 20px ;
}
.client-location{
  font-size: 14px !important;
  font-weight: 600;
  margin-bottom: 10px !important;
  margin-top: 20px !important;
  color: #00000085 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  gap: 5px;
}
.button-read-more{
  position: static
}
.read-more-button span {
    display: block;
    width: 100%;
    text-align: right !important;
    transform: none !important;
    font-size: 13px !important;
}
.read-more-button{
  height: fit-content !important;
}
  </style>
